module.exports = require("@swa-ui/core/src/ProgressTracker/ProgressTracker.module.scss");